module.exports = __webpack_public_path__ + "img/FR19806.4afe8351.svg";